const BASE_URL = process.env.REACT_APP_API_URL || '/api';

const getToken = () => localStorage.getItem('dayflow-token')
const setToken = (t) => localStorage.setItem('dayflow-token', t)
const removeToken = () => localStorage.removeItem('dayflow-token')

const headers = () => {
  let workspaceId = ''
  try {
    const storage = JSON.parse(localStorage.getItem('workspace-storage'))
    workspaceId = storage?.state?.activeWorkspaceId || ''
  } catch(e) {}

  return {
    'Content-Type': 'application/json',
    ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
    ...(workspaceId ? { 'X-Workspace-Id': workspaceId } : {})
  }
}

const fetchWithAuth = async (url, options = {}) => {
  let response = await fetch(url, { ...options, headers: { ...headers(), ...options.headers } })
  
  if (response.status === 401) {
    try {
      const refreshResponse = await fetch(`${BASE_URL}/auth/refresh`, { method: 'POST', credentials: 'include' })
      if (refreshResponse.ok) {
        const { token } = await refreshResponse.json()
        setToken(token)
        response = await fetch(url, { ...options, headers: { ...headers(), ...options.headers } })
      } else {
        removeToken()
        window.location.href = '/login'
      }
    } catch(e) {
      removeToken()
      window.location.href = '/login'
    }
  }
  return response.json()
}

let googleSyncRequest = null
const syncGoogleOnce = () => {
  if (!googleSyncRequest) {
    googleSyncRequest = fetchWithAuth(`${BASE_URL}/google/sync`)
      .finally(() => { googleSyncRequest = null })
  }
  return googleSyncRequest
}

const api = {
  registro: (datos) =>
    fetch(`${BASE_URL}/auth/registro`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(datos)
    }).then(r => r.json()),

  login: (datos) =>
    fetch(`${BASE_URL}/auth/login`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(datos),
      credentials: 'same-origin'
    }).then(r => r.json()),

  me: () => fetchWithAuth(`${BASE_URL}/auth/profile`),

  recuperarContrasena: (email) =>
    fetch(`${BASE_URL}/auth/recuperar-contrasena`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ email })
    }).then(r => r.json()),

  restablecerContrasena: (email, codigo, nueva_password) =>
    fetch(`${BASE_URL}/auth/restablecer-contrasena`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ email, codigo, nueva_password })
    }).then(r => r.json()),

  actualizarPerfil: (datos) => fetchWithAuth(`${BASE_URL}/auth/profile`, { method: 'PUT', body: JSON.stringify(datos) }),

  getSessions: () => fetchWithAuth(`${BASE_URL}/sessions/`),
  revokeSession: (id) => fetchWithAuth(`${BASE_URL}/sessions/${id}`, { method: 'DELETE' }),

  logout: () => fetchWithAuth(`${BASE_URL}/auth/logout`, { method: 'POST' }),

  // Tareas
  getTareas: () => fetchWithAuth(`${BASE_URL}/tareas/`),
  crearTarea: (datos) => fetchWithAuth(`${BASE_URL}/tareas/`, { method: 'POST', body: JSON.stringify(datos) }),
  actualizarTarea: (id, datos) => fetchWithAuth(`${BASE_URL}/tareas/${id}`, { method: 'PUT', body: JSON.stringify(datos) }),
  eliminarTarea: (id) => fetchWithAuth(`${BASE_URL}/tareas/${id}`, { method: 'DELETE' }),

  // Notas
  getNotas: () => fetchWithAuth(`${BASE_URL}/notas/`),
  crearNota: (datos) => fetchWithAuth(`${BASE_URL}/notas/`, { method: 'POST', body: JSON.stringify(datos) }),
  eliminarNota: (id) => fetchWithAuth(`${BASE_URL}/notas/${id}`, { method: 'DELETE' }),

  // Hábitos
  getHabitos: () => fetchWithAuth(`${BASE_URL}/habitos/`),
  crearHabito: (datos) => fetchWithAuth(`${BASE_URL}/habitos/`, { method: 'POST', body: JSON.stringify(datos) }),
  actualizarHabito: (id, datos) => fetchWithAuth(`${BASE_URL}/habitos/${id}`, { method: 'PUT', body: JSON.stringify(datos) }),
  eliminarHabito: (id) => fetchWithAuth(`${BASE_URL}/habitos/${id}`, { method: 'DELETE' }),

  // Finanzas
  getFinanzas: () => fetchWithAuth(`${BASE_URL}/transactions/`),
  crearFinanza: (datos) => fetchWithAuth(`${BASE_URL}/transactions/`, { method: 'POST', body: JSON.stringify(datos) }),
  eliminarFinanza: (id) => fetchWithAuth(`${BASE_URL}/transactions/${id}`, { method: 'DELETE' }),

  getMetas: () => fetchWithAuth(`${BASE_URL}/transactions/metas`),
  crearMeta: (datos) => fetchWithAuth(`${BASE_URL}/transactions/metas`, { method: 'POST', body: JSON.stringify(datos) }),
  actualizarMeta: (id, datos) => fetchWithAuth(`${BASE_URL}/transactions/metas/${id}`, { method: 'PUT', body: JSON.stringify(datos) }),
  eliminarMeta: (id) => fetchWithAuth(`${BASE_URL}/transactions/metas/${id}`, { method: 'DELETE' }),

  // Rutinas (ejemplo, se pueden cambiar igual)
  getRutinas: () => fetchWithAuth(`${BASE_URL}/rutinas/`),
  crearRutina: (datos) => fetchWithAuth(`${BASE_URL}/rutinas/`, { method: 'POST', body: JSON.stringify(datos) }),
  actualizarRutina: (id, datos) => fetchWithAuth(`${BASE_URL}/rutinas/${id}`, { method: 'PUT', body: JSON.stringify(datos) }),
  eliminarRutina: (id) => fetchWithAuth(`${BASE_URL}/rutinas/${id}`, { method: 'DELETE' }),

  agregarEjercicio: (rutinaId, datos) => fetchWithAuth(`${BASE_URL}/rutinas/${rutinaId}/ejercicios`, { method: 'POST', body: JSON.stringify(datos) }),
  actualizarEjercicio: (id, datos) => fetchWithAuth(`${BASE_URL}/rutinas/ejercicios/${id}`, { method: 'PUT', body: JSON.stringify(datos) }),
  eliminarEjercicio: (id) => fetchWithAuth(`${BASE_URL}/rutinas/ejercicios/${id}`, { method: 'DELETE' }),

  getRegistros: () => fetchWithAuth(`${BASE_URL}/rutinas/registros`),
  crearRegistro: (datos) => fetchWithAuth(`${BASE_URL}/rutinas/registros`, { method: 'POST', body: JSON.stringify(datos) }),
  eliminarRegistro: (id) => fetchWithAuth(`${BASE_URL}/rutinas/registros/${id}`, { method: 'DELETE' }),

  // Calorías
  getAlimentos: () => fetchWithAuth(`${BASE_URL}/calorias/alimentos`),
  crearAlimento: (datos) => fetchWithAuth(`${BASE_URL}/calorias/alimentos`, { method: 'POST', body: JSON.stringify(datos) }),
  eliminarAlimento: (id) => fetchWithAuth(`${BASE_URL}/calorias/alimentos/${id}`, { method: 'DELETE' }),

  getRegistrosComida: (fecha) => fetchWithAuth(`${BASE_URL}/calorias/registros${fecha ? `?fecha=${fecha}` : ''}`),
  crearRegistroComida: (datos) => fetchWithAuth(`${BASE_URL}/calorias/registros`, { method: 'POST', body: JSON.stringify(datos) }),
  eliminarRegistroComida: (id) => fetchWithAuth(`${BASE_URL}/calorias/registros/${id}`, { method: 'DELETE' }),

  getObjetivo: () => fetchWithAuth(`${BASE_URL}/calorias/objetivo`),
  actualizarObjetivo: (datos) => fetchWithAuth(`${BASE_URL}/calorias/objetivo`, { method: 'PUT', body: JSON.stringify(datos) }),
  analizarImagenComida: (imagenBase64) => fetchWithAuth(`${BASE_URL}/calorias/analizar-imagen`, { method: 'POST', body: JSON.stringify({ imagen: imagenBase64 }) }),
    
  // Logros
  getLogros: () => fetchWithAuth(`${BASE_URL}/logros/`),
  verificarLogros: () => fetchWithAuth(`${BASE_URL}/logros/verificar`, { method: 'POST' }),
  getLogrosDisponibles: () => fetchWithAuth(`${BASE_URL}/logros/disponibles`),
  
  // Google Calendar
  googleLogin: () => fetchWithAuth(`${BASE_URL}/google/login`),
  googleStatus: () => fetchWithAuth(`${BASE_URL}/google/status`),
  getGoogleAuthUrl: () => fetch(`${BASE_URL}/google/auth-url`).then(r => r.json()),
  syncGoogle: syncGoogleOnce,
  syncFeriados: () => fetchWithAuth(`${BASE_URL}/google/feriados-ar`),

  // Notificaciones
  getNotificaciones: () => fetchWithAuth(`${BASE_URL}/notificaciones/`),
  leerNotificacion: (id) => fetchWithAuth(`${BASE_URL}/notificaciones/${id}/leer`, { method: 'PUT' }),

  // Workspaces & Members
  getWorkspaces: () => fetchWithAuth(`${BASE_URL}/workspaces/`),
  crearWorkspace: (datos) => fetchWithAuth(`${BASE_URL}/workspaces/`, { method: 'POST', body: JSON.stringify(datos) }),
  actualizarWorkspace: (id, datos) => fetchWithAuth(`${BASE_URL}/workspaces/${id}`, { method: 'PUT', body: JSON.stringify(datos) }),
  eliminarWorkspace: (id) => fetchWithAuth(`${BASE_URL}/workspaces/${id}`, { method: 'DELETE' }),
  getMiembros: (workspaceId) => fetchWithAuth(`${BASE_URL}/workspaces/${workspaceId}/members`),
  invitarMiembro: (workspaceId, datos) => fetchWithAuth(`${BASE_URL}/workspaces/${workspaceId}/members`, { method: 'POST', body: JSON.stringify(datos) }),
  removerMiembro: (workspaceId, memberId) => fetchWithAuth(`${BASE_URL}/workspaces/${workspaceId}/members/${memberId}`, { method: 'DELETE' }),

  // Admin
  adminGetUsers: () => fetchWithAuth(`${BASE_URL}/admin/users`),
  adminUpdateUser: (id, datos) => fetchWithAuth(`${BASE_URL}/admin/users/${id}`, { method: 'PUT', body: JSON.stringify(datos) }),
  adminResetPassword: (id) => fetchWithAuth(`${BASE_URL}/admin/users/${id}/reset-password`, { method: 'POST' }),
}

export default api
